import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(0.5),
    "&:before": {
      display: "none",
    },
    "&:nth-child(even)": {
      background: theme.palette.programingOnDemandGrouped.subModule.backgroundColor,
      marginBottom: theme.spacing(0.5),
      paddingBottom: 0,
      borderRadius: 4,
    },
  },
  summary: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.75),
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
    },
  },
  content: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      gap: theme.spacing(1),
    },
  },
  dateContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('xs')]: {
      order: 1,
    },
  },
  dayMonth: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(0.5),
    borderRadius: 4,
    width: 32,
    height: 32,
    [theme.breakpoints.down('xs')]: {
      width: 28,
      height: 28,
    },
    "&.even-color": {
      backgroundColor: theme.palette.even.main,
      "& .MuiTypography-root": {
        color: theme.palette.even.contrastText + "!important",
      },
    },
    "&.odd-color": {
      backgroundColor: theme.palette.odd.main,
      "& .MuiTypography-root": {
        color: theme.palette.odd.contrastText + "!important",
      },
    },
  },
  day: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.75rem",
    },
  },
  month: {
    fontSize: "0.625rem",
    textTransform: "uppercase",
    lineHeight: 1,
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.5rem",
    },
  },
  divider: {
    margin: theme.spacing(0, 1.5),
    height: 32,
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  schedule: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    [theme.breakpoints.down('xs')]: {
      order: 2,
      width: '100%',
      marginTop: theme.spacing(0.5),
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1rem",
      [theme.breakpoints.down('xs')]: {
        fontSize: "0.875rem",
      },
    },
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.87)",
      [theme.breakpoints.down('xs')]: {
        fontSize: "0.75rem",
      },
    },
  },
  title: {
    flex: 1,
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "rgba(0, 0, 0, 0.87)",
    [theme.breakpoints.down('xs')]: {
      order: 3,
      width: '100%',
      fontSize: "0.8125rem",
      marginTop: theme.spacing(0.5),
    },
  },
  details: {
    padding: theme.spacing(1.5),
    flexDirection: "column",
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
    },
  },
  occupations: {
    width: "100%",
  },
  profile: {
    marginBottom: theme.spacing(0.5),
    fontSize: "0.8125rem",
    color: "rgba(0, 0, 0, 0.87)",
    [theme.breakpoints.down('xs')]: {
      fontSize: "0.75rem",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
}));
